import "./App.css";
import { Link } from "react-router-dom";
function ApplicationHomepage() {
  return (
    <div className="mt-20 text ">
      <div className="text-zinc-200 pt-30 text lg:mx-[15%] mx-[5%]">
        <div className="text-3xl font-bold ml-4">Available Applications</div>

        {/* Desktop */}
        <div className="themeBg mt-8 rounded-lg  md:block hidden">
          <div className="text-lg font-bold h-30 hover:bg-gray-800 flex items-center rounded-lg">
            <div className="ml-4 text-4xl text-green-500 border-y-green-500 border-y-2">
              NEW
            </div>

            <div className="ml-23 w-[80%]">
              Omnicraft SMP New Member Application
              <div className="text-sm text-zinc-500">
                This application is for NEW MEMBERS ONLY. If you were a former
                member and looking to apply again please use the application
                below.
              </div>
            </div>
            <Link
              to="/new-member-application"
              className="bg-green-600 w-[20%] hover:text-zinc-200 hover:bg-green-600/70 text-center rounded-md link mx-4"
            >
              Apply
            </Link>
          </div>
          <hr className="w-[98%] ml-[1%] bg-zinc-500"></hr>
          <div className="text-lg font-bold h-30 hover:bg-gray-800 flex items-center rounded-lg">
            <div className="ml-4 text-4xl text-orange-500 border-y-orange-500 border-y-2">
              FORMER
            </div>
            <div className="ml-4 w-[80%]">
              Omnicraft SMP Former Member Application
              <div className="text-sm text-zinc-500">
                Please note this application is for Former Members only. New
                Members who utilize this application will be denied.
              </div>
            </div>
            <Link
              to="/former-member-application"
              className="bg-green-600 w-[20%] hover:text-zinc-200 hover:bg-green-600/70 text-center rounded-md link mx-4"
            >
              Apply
            </Link>
          </div>
        </div>

        {/* Mobile */}
        <div className="themeBg mt-8 rounded-lg  md:hidden block">
          <div className="text-lg font-bold h-60 hover:bg-gray-800 items-center rounded-lg w-full">
            <div className="pt-4 w-full">
              <div className="ml-4 w-21 text-4xl text-green-500 border-y-green-500 border-y-2 ">
                NEW
              </div>

              <div className="ml-4 my-2 mr-1">
                Omnicraft SMP New Member Application
                <div className="text-sm text-zinc-500">
                  This application is for NEW MEMBERS ONLY. If you were a former
                  member and looking to apply again please use the application
                  below.
                </div>
              </div>
            </div>
            <Link
              to="/new-member-application"
              className="bg-green-600 hover:text-zinc-200 hover:bg-green-600/70 text-center rounded-md link mx-4 px-[38%]"
            >
              Apply
            </Link>
          </div>

          <hr className="w-[98%] ml-[1%] bg-zinc-500"></hr>
          <div className="text-lg font-bold h-56 hover:bg-gray-800 items-center rounded-lg">
            <div className="ml-4 w-38 text-4xl text-orange-500 border-y-orange-500 border-y-2 mt-4">
              FORMER
            </div>
            <div className="ml-4 w-[80%]">
              Omnicraft SMP Former Member Application
              <div className="text-sm text-zinc-500">
                Please note this application is for Former Members only. New
                Members who utilize this application will be denied.
              </div>
            </div>
            <Link
              to="/former-member-application"
              className="bg-green-600 w-[100%] hover:text-zinc-200 hover:bg-green-600/70 text-center rounded-md link mx-4 px-[38%]"
            >
              Apply
            </Link>
          </div>
        </div>
      </div>
      <div className="p-10"></div>
    </div>
  );
}
export default ApplicationHomepage;
